function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require('./dist/index'));


//////////////////
// WEBPACK FOOTER
// /var/lib/jenkins/workspace/Angular_wig_cropmap_master/node_modules/angular2-highcharts/index.js
// module id = ../../../../angular2-highcharts/index.js
// module chunks = vendor